import { Button, Space } from "antd";
import { ReactNode } from "react";

interface InfoTitleProps {
  className?: string;
  icon: ReactNode;
  children: ReactNode;
  align?: "start" | "end" | "center" | "baseline";
  buttonClassName?: string;
}

export default function InfoTitle({
  className = "",
  icon,
  children,
  align = "center",
  buttonClassName = "disabled:!text-body-text",
}: InfoTitleProps) {
  return (
    <Space align={align} className={`w-full ${className}`} size={8}>
      <Button
        className={`middle-button !border-none !bg-[#fff8df] disabled:!cursor-auto ${buttonClassName}`}
        icon={icon}
        disabled
      />
      <h3 className="text-header text-xl font-semibold">{children}</h3>
    </Space>
  );
}
